import { render, staticRenderFns } from "./cardContent.vue?vue&type=template&id=11c2e594&scoped=true&"
import script from "./cardContent.vue?vue&type=script&lang=js&"
export * from "./cardContent.vue?vue&type=script&lang=js&"
import style0 from "./cardContent.vue?vue&type=style&index=0&id=11c2e594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2e594",
  null
  
)

export default component.exports